import prepareTranslate from '@/helpers/dictionary';
import { ACCORD_TYPE } from '@/helpers/enums';
import {
  Button,
  Center,
  Grid,
  NumberInput,
  Select,
  TextInput,
} from '@mantine/core';
import PropTypes from 'prop-types';

function CreateAgentAlternativeFundInProcess(props) {
  const {
    form,
    productsOptions,
    companiesOptions,
    disabled,
  } = props;

  const t = prepareTranslate();

  const alternativeFundIndex = form.getValues().alternativeFunds
    ? form.getValues().alternativeFunds.length - 1
    : 0;

  const alternativeFundAccordType = form.getValues().alternativeFunds?.[
    alternativeFundIndex
  ]?.accordType;

  return (
    <>
      <Grid gutter={{ base: 'xl' }} mb='lg'>
        <Grid.Col span={{ base: 4 }}>
          <Select
            label={t('components.createAgentAlternativeFundInProcess.company')}
            data={companiesOptions}
            searchable
            clearable
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.companyId`,
            )}
            disabled={disabled}
          />
          <TextInput
            autoComplete='off'
            maxLength={25}
            label={t('components.createAgentAlternativeFundInProcess.uid')}
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.uid`,
            )}
            disabled={disabled}
          />
          <TextInput
            label={t('components.createAgentAlternativeFundInProcess.alternativeFundName')}
            key={form.key(
              `alternativeFunds.${alternativeFundIndex}.alternativeFundName`,
            )}
            maxLength={7}
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.alternativeFundName`,
            )}
            disabled={disabled}
          />

        </Grid.Col>
        <Grid.Col span={{ base: 4 }}>
          <Select
            withAsterisk
            label={t('components.createAgentAlternativeFundInProcess.branch')}
            data={productsOptions}
            searchable
            clearable
            key={form.key(
              `alternativeFunds.${alternativeFundIndex}.branchId`,
            )}
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.branchId`,
            )}
            disabled={disabled}
          />
          <Select
            withAsterisk
            label={t('components.createAgentAlternativeFundInProcess.accordType')}
            defaultValue={ACCORD_TYPE[1].value}
            data={ACCORD_TYPE}
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.accordType`,
            )}
            disabled={disabled}
          />
          <TextInput
            label={t('components.createAgentAlternativeFundInProcess.alternativeFundType')}
            key={form.key(
              `alternativeFunds.${alternativeFundIndex}.alternativeFundType`,
            )}
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.alternativeFundType`,
            )}
            disabled={disabled}
          />

        </Grid.Col>
        <Grid.Col span={{ base: 4 }}>
          <TextInput
            autoComplete='off'
            label={t('components.createAgentAlternativeFundInProcess.number')}
            maxLength={7}
            withAsterisk
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.alternativeFundNumber`,
            )}
            disabled={disabled}
          />
          {
            alternativeFundAccordType === 'independent' ? (
              <NumberInput
                autoComplete='off'
                label={t('components.createAgentAlternativeFundInProcess.commission')}
                key={form.key(
                  `alternativeFunds.${alternativeFundIndex}.agentCommission`,
                )}
                maxLength={7}
                {...form.getInputProps(
                  `alternativeFunds.${alternativeFundIndex}.agentCommission`,
                )}
                disabled={disabled}
              />
            ) : (
              <NumberInput
                autoComplete='off'
                label={t('components.createAgentAlternativeFundInProcess.commission')}
                key={form.key(
                  `alternativeFunds.${alternativeFundIndex}.employeeAgentCommission`,
                )}
                maxLength={7}
                {...form.getInputProps(
                  `alternativeFunds.${alternativeFundIndex}.employeeAgentCommission`,
                )}
                disabled={disabled}
              />
            )
          }
          <TextInput
            label={t('components.createAgentAlternativeFundInProcess.comments')}
            key={form.key(
              `alternativeFunds.${alternativeFundIndex}.comments`,
            )}
            {...form.getInputProps(
              `alternativeFunds.${alternativeFundIndex}.comments`,
            )}
            disabled={disabled}
          />
        </Grid.Col>
      </Grid>
      <Center>
        <Button
          type='submit'
        >
          {t('components.createAgentAgreementInProcess.submit')}
        </Button>
      </Center>
    </>
  );
}

CreateAgentAlternativeFundInProcess.propTypes = {
  form: PropTypes.shape({
    insertListItem: PropTypes.func.isRequired,
    getValues: PropTypes.func.isRequired,
    key: PropTypes.func.isRequired,
    getInputProps: PropTypes.func.isRequired,
  }).isRequired,
  productsOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  companiesOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  agentData: PropTypes.object,
  currentIdentifier: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
    identifierNumber: PropTypes.string.isRequired,
    company: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    product: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
};

export default CreateAgentAlternativeFundInProcess;
